import { ConfirmFormStrategy } from '../confirm-form.interface';

export class RemoveMemberStrategy implements ConfirmFormStrategy {
  readonly header = 'members-list.remove-dialog.remove-member';
  readonly message = 'members-list.remove-dialog.are-you-sure-you-would-like-to-remove';
  readonly confirmButtonLabel = 'members-list.remove-dialog.remove-member';
  readonly cancelButtonLabel = 'members-list.remove-dialog.cancel';
}
